import React, { useEffect, useState } from 'react';
import { toInteger } from 'lodash';

import {
  Box,
  Container,
  makeStyles,
  Card,
  CardContent
} from '@material-ui/core';

import { MdMessage } from "react-icons/md";

import Page from 'src/components/Page';
import api from '../../services/api'

import Alerts from '../../utils/alerts';
import Confirmations from '../../utils/confirmations';

import Results from './Results';
import Toolbar from './Toolbar';
import Mailing from './Mailing';
import Create from './Create';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const defaultItem = {
  name: '',
  template: 'alarms',
  enabled: true,
  includes: [],
  excludes: [],
  mailto: []
}

const defaultDependencies = {
  loaded: false,
  users: [],
  templates: [],
  groups: []
}

const defaultState = {
  loaded: false,
  records: 10,
  pages: 0,
  page: 0,
  count: 0,
  rows: []
}

const defaultStartDateTime = new Date();
const defaultEndDateTime = new Date();

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const defaultResultColumns = [
  { name: 'Descrição', field: 'item.name', size: -1, sortable: 'name', exportable: 0, wrap: 1 },
  { name: 'Tipo', field: 'templateName(dependencies, item.template)', size: -1, sortable: null, exportable: 0, wrap: 1 },
  { name: 'Habilitado', field: '((item.enabled) ? "Sim" : "Não")', size: -1, sortable: null, exportable: 0, wrap: 1 },
  { name: 'Assinantes', field: 'formatNumber((item.mailto) ? item.mailto.length : 0, "0")', size: -1, sortable: null, exportable: 0, wrap: 1 },
  { name: 'Restrições', field: 'formatNumber((item.includes) ? item.includes.length : 0, "0")', size: -1, sortable: null, exportable: 0, wrap: 1 },
  { name: 'Exceções', field: 'formatNumber((item.excludes) ? item.excludes.length : 0, "0")', size: -1, sortable: null, exportable: 0, wrap: 1 },
  { name: 'Criação', field: 'formatDate(item.createdAt)', size: -1, sortable: 'createdAt', exportable: 0, wrap: 1 }
];

const defaultEmptyMessage = "Nenhuma Equipe Foi Encontrada.";

const defaultfullMode = {
  mode: MODE_FULL,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultCompactMode = {
  mode: MODE_COMPACT,
  create: LEVEL_ACCESS_ENABLED,
  update: LEVEL_ACCESS_ENABLED,
  delete: LEVEL_ACCESS_ENABLED,
  config: LEVEL_ACCESS_HIDE,
  export: LEVEL_ACCESS_HIDE,
  empty: defaultEmptyMessage,
  columns: defaultResultColumns
};

const defaultResultModes = [defaultfullMode, defaultCompactMode];

const defaultVisions = [
  { id: 1, name: 'Notificações pelo Nome', refine: 1, label: 'Notificações da equipe', history: 0 },
  { id: 2, name: 'Notificações pelo Nome e Data de Criação', refine: 2, label: 'Notificações da equipe', history: 1 }
];

const defaultFilter = {
  pagina: 0,
  registros: 10,
  inicio: defaultStartDateTime,
  final: defaultEndDateTime,
  palavrachave: '',
  ordenacao: 'asc',
  ordem: '',
  visao: defaultVisions[0]
}

const Mailings = () => {

  const classes = useStyles();

  const [item, setItem] = useState(defaultItem);
  const [openCreationDialog, setOpenCreationDialog] = useState(false);
  const [openEditionDialog, setOpenEditionDialog] = useState(false);
  const [openDeletionDialog, setOpenDeletionDialog] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [message, setMessage] = useState({});
  const [filter, setFilter] = useState(defaultFilter);
  const [vision, setVision] = useState(defaultVisions[0]);
  const [resultModes, setResultModes] = useState(defaultResultModes);
  const [selectedMode, setSelectedMode] = useState(MODE_FULL);
  const [dependencies, setDependencies] = useState(defaultDependencies);
  const [openTreatmentDialog, setOpenTreatmentDialog] = useState(false);

  const [state, setState] = useState(defaultState);

  const [companyId, setCompanyId] = useState(localStorage.getItem('companyid'));
  const [checkedMailto, setCheckedMailto] = useState([]);
  const [checkedExcludes, setCheckedExcludes] = useState([]);
  const [checkedIncludes, setCheckedIncludes] = useState([]);

  const openExportDialog = async (format) => {
    setMessage({ error: true, warn: true, detail: "Função não implementada." });
    setOpenAlert(true);
  }

  const openEdition = (item) => {
    api.get('/mailings/dependencies/' + companyId, {}).then((response) => {
      setItem(item);
      setCheckedMailto(item.mailto);
      setCheckedExcludes(item.excludes);
      setCheckedIncludes(item.includes);
      setDependencies({
        loaded: true,
        messages: response.data.messages,
        templates: response.data.templates,
        groups: response.data.groups
      });
      setOpenEditionDialog(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao editar a notificação.', detail: error.message });
      setOpenAlert(true);
    })

  }

  const openCreation = async (item) => {
    setItem(item);
    setOpenCreationDialog(true);
  }

  const openDeletion = (item) => {
    setItem(item);
    setMessage({
      title: 'Notificação',
      message: 'Deseja excluir a notificação selecionada?',
      warn: 'Esta ação pode interferir nas notificações e chamados.',
      details: ['Esta ação irá impedir os assinantes de receberem essa notificação.']
    });
    setOpenDeletionDialog(true);
  }

  const openTreatment = (item) => {
    setItem(item);
    setMessage({ error: true, warn: true, detail: "Função não implementada." });
    setOpenAlert(true);
  }

  const closeDeletion = () => {
    setOpenDeletionDialog(false);
  };

  const closeEdition = () => {
    setOpenEditionDialog(false);
  };

  const closeCreation = () => {
    setOpenCreationDialog(false);
  };

  const closeTreatment = () => {
    setOpenTreatmentDialog(false);
  };

  const closeAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };

  const updateTreatmentValues = (values) => {
    setItem(values);
    refreshItems();
  }

  const updateValues = (values) => {
    values.mailto = checkedMailto;
    values.includes = checkedIncludes;
    values.excludes = checkedExcludes;
    api.put('/mailings/' + values._id, values).then((response) => {
      if (!response.data.error) {
        refreshItems();
        closeEdition();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao atualizar a notificação.', detail: error.message });
      setOpenAlert(true);
    })
  };

  const createValues = (values) => {
    values.company = companyId;
    values.mailto = checkedMailto;
    values.includes = checkedIncludes;
    values.excludes = checkedExcludes;
    api.post('/mailings/' + values._id, values).then((response) => {
      if (!response.data.error) {
        refreshItems();
        closeCreation();
      }
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao criar a notificação.', detail: error.message });
      setOpenAlert(true);
    })
  };

  const updateDependencies = async (values) => {

  };

  const deleteValues = (values) => {
    api.delete('/mailings/' + values._id).then((response) => {
      if (!response.data.error) {
        refreshItems();
      }
      closeDeletion();
      setMessage(response.data);
      setOpenAlert(true);
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao remover a notificação.', detail: error.message });
      setOpenAlert(true);
    })
  };

  const changeSort = (column, order) => {
    var value = {
      ...filter,
      ordem: column.sortable,
      ordenacao: order,
      pagina: 0,
    };
    setFilter(value);
    api.post('/mailings/history', { filtro: value, company: companyId }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: ((response.data.count > 0) ? toInteger((response.data.count / value.registros)) + 1 : 0),
          page: (response.data.count == 0) ? 0 : value.pagina + 1,
          count: response.data.count,
          rows: response.data.rows
        });
        setDependencies({
          loaded: true,
          messages: [],
          templates: response.data.templates,
          groups: []
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao recuperar lista de notificações.', detail: error.message });
      setOpenAlert(true);
    })
  }

  const changeFilter = (startDateTime, endDateTime, vision, keyword, page, rows) => {
    var value = {
      ...filter,
      pagina: page,
      registros: rows,
      inicio: startDateTime,
      final: endDateTime,
      palavrachave: keyword,
      visao: vision
    };
    setVision(vision);
    setFilter(value);
    api.post('/mailings/history', { filtro: value, company: companyId }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: ((response.data.count > 0) ? toInteger((response.data.count / value.registros)) + 1 : 0),
          page: (response.data.count == 0) ? 0 : value.pagina + 1,
          count: response.data.count,
          rows: response.data.rows
        });
        setDependencies({
          loaded: true,
          messages: [],
          templates: response.data.templates,
          groups: []
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao recuperar lista de notificações.', detail: error.message });
      setOpenAlert(true);
    })
  }

  const refreshItems = () => {
    api.post('/mailings/history', { filtro: filter, company: companyId }, {}).then((response) => {
      if (!response.data.error) {
        setState({
          loaded: true,
          pages: ((response.data.count > 0) ? toInteger((response.data.count / filter.registros)) + 1 : 0),
          page: (response.data.count == 0) ? 0 : filter.pagina + 1,
          count: response.data.count,
          rows: response.data.rows
        });
        setDependencies({
          loaded: true,
          messages: [],
          templates: response.data.templates,
          groups: []
        });
      } else {
        setState(defaultState);
        setMessage(response.data);
        setOpenAlert(true);
      }
    }).catch((error) => {
      console.error(error);
      setMessage({ error: true, fatal: true, message: 'Erro ao recuperar lista de notificações.', detail: error.message });
      setOpenAlert(true);
    })
  }

  const handleToggle = (value, set) => () => {
    if (set == 'mailto') {
      const currentIndex = checkedMailto.indexOf(value);
      const newChecked = [...checkedMailto];

      if (currentIndex === -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }
      setCheckedMailto(newChecked);
    } else if (set == 'includes') {
      const currentIndex = checkedIncludes.indexOf(value);
      const newChecked = [...checkedIncludes];

      if (currentIndex === -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }
      setCheckedIncludes(newChecked);

    } else if (set == 'excludes') {
      const currentIndex = checkedExcludes.indexOf(value);
      const newChecked = [...checkedExcludes];

      if (currentIndex === -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }
      setCheckedExcludes(newChecked);
    }
  };

  useEffect(() => {
    if (!state.loaded) {
      refreshItems();
    }
    return
  }, []);

  return (
    <Page
      className={classes.root}
      title="Notificação"
    >
      <Container maxWidth={false}>

        <Toolbar
          icon={MdMessage}
          item={defaultItem}
          resultset={state}
          resultModes={resultModes}
          vision={vision}
          visions={defaultVisions}
          selectedMode={selectedMode}
          openCreation={openCreation}
          changeFilter={changeFilter}
        />

        <Alerts message={message}
          open={openAlert}
          closeAlert={closeAlert} />

        <Confirmations item={item}
          message={message}
          open={openDeletionDialog}
          close={closeDeletion}
          confirmation={deleteValues} />

        <Confirmations item={item}
          message={message}
          open={openTreatmentDialog}
          close={closeTreatment}
          confirmation={updateTreatmentValues} />

        <Mailing item={item}
          open={openEditionDialog}
          closeEdition={closeEdition}
          updateValues={updateValues}
          dependencies={dependencies}
          updateDependencies={updateDependencies}
          checkedMailto={checkedMailto}
          checkedExcludes={checkedExcludes}
          checkedIncludes={checkedIncludes}
          handleToggle={handleToggle}
        />

        <Create item={item}
          open={openCreationDialog}
          closeEdition={closeCreation}
          updateValues={createValues}
          dependencies={dependencies}
          updateDependencies={updateDependencies}
          checkedMailto={checkedMailto}
          checkedExcludes={checkedExcludes}
          checkedIncludes={checkedIncludes}
          handleToggle={handleToggle}
        />

        <Box mt={3}>
          <Card>
            <CardContent>
              <Results
                resultSet={state}
                resultModes={resultModes}
                icon={MdMessage}
                vision={vision}
                selectedMode={selectedMode}
                openEdition={openEdition}
                openDeletion={openDeletion}
                openTreatment={openTreatment}
                openExportDialog={openExportDialog}
                changeSort={changeSort}
                dependencies={dependencies}
              />
            </CardContent>
          </Card>
        </Box>

      </Container>
    </Page>
  );
};

export default Mailings;
